import type { DSData } from 'webapp-types';

import type DataSelect from 'webapp/models-custom/data-select';
import DsDataOutputOther from 'webapp/models-custom/ds-data/output/other';
import DsDataOutputTopLevel from 'webapp/models-custom/ds-data/output/top';
import DsDataRootBase from 'webapp/models-custom/ds-data/root/base';
import DsDataRootCompare from 'webapp/models-custom/ds-data/root/compare';

export default class DsDataRootTopLevel extends DsDataRootBase {
	override outputs: DsDataOutputTopLevel[];

	compareRoots: DsDataRootCompare[];

	override scale: number | null;

	mediaMap: DSData.MediaMap;

	isTop = true; // to distinguish from compare root without instanceof

	constructor(dataSelect: DataSelect, rawData: DSData.RootTop) {
		super(dataSelect, rawData);

		this.scale = rawData.scale;

		this.outputs = (rawData.data || []).map((d) => new DsDataOutputTopLevel(this, d));

		this.compareRoots = (rawData.compares || []).map((compareData, idx) => {
			return new DsDataRootCompare(dataSelect, compareData, idx);
		});

		this.mediaMap = rawData.mediaMap || {};

		this.dimensions = rawData.dimensions || [];

		this.outputsOther = (rawData.others || []).map((d) => new DsDataOutputOther(this, d));
	}

	override getOutputByDimensionValuesAndUnit(
		dimensionValues: DSData.DimensionsAndValuesMap,
		unit: string | null,
	) {
		return super.getOutputByDimensionValuesAndUnit(
			dimensionValues,
			unit,
		) as DsDataOutputTopLevel | null;
	}
}
